export const blogsRouteNames = {
  default: 'blogs-list',
  list:  'blogs-site-list',
  new: 'blogs-site-new',
  blogSettings: 'blog-setting',
  blogImport: 'blog-import',
  blogImportId: 'blog-import-id',
  blogCsvImport: 'blog-csv-import',
  blogCsvImportId: 'blog-csv-import-id',
  blogCsvPostEditor: 'blog-csv-post-editor',
  settings: 'blogs-settings',
  edit:'blogs-post-edit',
  postSettings: 'blogs-post-settings',
  postPreview:'blogs-post-preview',
  postVersions: 'blogs-post-history',
  authors: 'blogs-authors',
  authorsEdit: 'blogs-authors-edit',
  categories: 'blogs-categories',
  categoriesEdit: 'blogs-categories-edit',
  post: 'blogs-post',
  postDetails: 'blogs-post-id',
}
